// extracted by mini-css-extract-plugin
export default {"title":"ServicePage_title__qHynA","text":"ServicePage_text__yjmra"};